<template>
  <h1>
    Así se comportan los homicidios y desapariciones de jóvenes para hombres y
    mujeres
  </h1>
  <div class="controles">
    <label for="regional">Selecciona una región </label>
    <select class="regional" name="regional" v-model="regionSeleccionada">
      <option v-for="region in regiones" :key="region">
        {{ region }}
      </option>
    </select>
  </div>
  <div class="graficas">
    <GraficaAreas
      class="areas"
      :datos="data[regionSeleccionada].datos_tiempo"
    />
    <StackedBars
      class="stackedbars"
      :datos="data[regionSeleccionada].datos_marimeko"
      :region="data[regionSeleccionada].region"
    />
  </div>
  <p class="fuente">
    Para estos gráficos se tomaron en cuenta únicamente los registros de
    personas cuyo sexo estaba determinado. Los porcentajes están redondeados.
    <br />
    <span class="highlight">Fuente</span>: Elaboración propia a partir de datos
    del INEGI y del RNPDNO.
  </p>
</template>

<script>
import datos from "@/assets/data_regional.json";
import GraficaAreas from "./GraficaAreas.vue";
import StackedBars from "./StackedBars.vue";

export default {
  name: "App",
  components: {
    GraficaAreas,
    StackedBars,
  },
  data() {
    return {
      data: datos,
      regiones: ["noreste", "noroeste", "centro", "occidente", "sureste"],
      regionSeleccionada: "noreste",
    };
  },
};
</script>
<style>
div.graficas {
  display: flex;
  flex-wrap: wrap;
}
.contenedor-graf {
  width: 48%;
  padding-left: 5px;
}
.titulo {
  margin: 10px;
  padding: 15px;
  font-size: 16px;
}
.controles {
  font-size: 20px;
}
.fuente {
  text-align: left;
  font-size: 12px;
  margin-left: 10px;
  margin-top: 2px;
}
.highlight {
  font-weight: bold;
}

@media (max-width: 769px) {
  .contenedor-graf {
    width: 100%;
  }
}
</style>
